<template>
  <div
    :class="[
      'dropdown choose-lang-box',
      { 'white-theme': specialHeader },
      className,
    ]"
  >
    <ul class="nav navbar-nav">
      <li class="dropdown">
        <a
          href="javascript:void(0)"
          id="current-lang"
          class="dropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          {{ currentLang.text }}
          <span class="caret"></span>
        </a>
        <ul class="dropdown-menu language-ul" aria-labelledby="current-lang">
          <li
            v-for="lang in languages"
            :key="lang.code"
            @click="changeLang(lang)"
            class="language-li"
          >
            <a href="javascript:void(0)" class="a-language">{{ lang.text }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import languages from "../lib/i18n";
import { funcUrlDel } from "../lib/utils";
import { mapState } from "vuex";

export default {
  name: "chooseLang",
  props: {
    className: { type: String },
  },
  data: function () {
    return {
      currentLang: {
        code: "",
        text: "",
      },
      showLangList: false,
      languages,
    };
  },
  computed: {
    ...mapState({
      specialHeader: (state) => state.header.specialHeader,
      isHeader: "isHeader",
    }),
  },
  created: function () {
    this.getInitLang();
  },
  methods: {
    getInitLang() {
      this.currentLang.code = this.$store.state.currentLang;
      this.matchLang();
    },
    matchLang() {
      for (let i = 0; i < this.languages.length; i++) {
        if (this.languages[i].code === this.currentLang.code) {
          this.currentLang = this.languages[i];
        }
      }
    },
    changeLang(lang) {
      this.currentLang = lang;
      window.localStorage.setItem("currentLang", lang.code);
      this.$store.commit("setCurrentLang", lang.code);
      window.sessionStorage.setItem("needUseNoCache", true);
      this.$nextTick(() => {
        window.location.replace(funcUrlDel("lang"));
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../assets/scss/variables";
@import "../assets/scss/activity";

* {
  padding: 0;
  margin: 0;
}

.navbar-nav {
  margin: 0;
  padding: 0;
}

.nav .open > a,
.nav > li > a:hover,
.nav > li > a:focus {
  border-color: $base-green;
}

.choose-lang-box {
  height: 100%;
  padding: 0;
  position: relative;
  display: inline-block;
  text-align: center;

  #current-lang {
    padding: 0;
    background-color: transparent;
    // line-height: 0.26rem;
    position: relative;
    // font-size: 0.14rem;
  }

  .language-ul {
    left: auto;
    right: 0;
    position: absolute;
    top: 0.35rem;
    padding: 0 0.1rem;
    background: white;
    box-shadow: 0 6px 0.24rem 0 rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    border: 1px solid #efefef;

    .language-li {
      list-style: none;
      border-bottom: 1px solid #efefef;
      line-height: 0.6rem;
      height: 0.6rem;
      width: 100%;
      padding: 0;
      color: #333333;
      letter-spacing: 0.33px;
      cursor: pointer;

      .a-language {
        line-height: 0.58rem;
        padding: 0;
        color: #333;
        text-align: center;
        &:hover {
          background: transparent;
          font-size: 0.16rem;
          font-weight: bold;
          letter-spacing: 0.38px;
        }
      }
    }
  }
}

.dashboard-header {
  #current-lang {
    display: block;
    line-height: 0.8rem;
    height: 0.8rem;
  }
  .language-ul {
    top: 0.65rem;
    right: 0;
  }
}
.choose-lang-box {
  #current-lang {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0.89px;
    text-align: center;
    font-weight: 500;
  }
}
// @mixin default-style() {
//   #current-lang {
//     color: $current-lang-color;
//     color: #fff;
//   }
// }

// @mixin transparent-style() {
//   #current-lang {
//     color: #fff;
//   }
// }

// @media screen and (min-width: 767px) {
//   .choose-lang-box {
//     .language-ul {
//       right: 0;
//     }
//   }
// }

// .choose-lang-box {
//   @include default-style();
//   &.white-theme {
//     @include transparent-style();
//   }
// }
</style>



// WEBPACK FOOTER //
// ChooseLang.vue?59d2fe7d